/**
 * CRF / visit issue status badge and labels (matches vStatus in DB).
 * Open or Resolved → "Open"; Closed → "Close".
 */
export function formatActionItemStatusForDisplay(status) {
  const raw = (status ?? '').toString().trim();
  if (!raw) return 'Open';
  const lo = raw.toLowerCase();
  if (lo === 'closed') return 'Close';
  if (lo === 'open' || lo === 'resolved') return 'Open';
  return raw;
}

/**
 * True when persisted <code>vIssueCategory</code> is the master "Others" row
 * (free text lives in <code>vIssueCategoryOther</code>). Matches create-issue UI.
 */
export function isIssueCategoryOthers(issueCategory) {
  const t = (issueCategory ?? '').toString().trim().toLowerCase();
  return t === 'others';
}

/** Map API status to Issue Review status dropdown value (Open / Resolved / Closed). */
export function normalizeActionItemStatusSelectValue(status) {
  const raw = (status ?? 'Open').toString().trim();
  const lo = raw.toLowerCase();
  if (lo === 'resolved') return 'Resolved';
  if (lo === 'closed') return 'Closed';
  if (lo === 'open') return 'Open';
  return raw;
}
